import { methodList, methodPriority, methodMove } from './request';
export default {
  data() {
    return {
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'sort',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '支付方式'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center',
        scopedSlots: {
          customRender: 'name'
        }
      }, {
        slots: {
          title: '优先使用'
        },
        dataIndex: 'isPriority',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'isPriority'
        }
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        key: '5',
        align: 'center',
        width: 230,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: []
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    getDataFun() {
      methodList().then(res => {
        console.log(res.items);
        this.data = res.items;
      });
    },
    priorityFun(val) {
      methodPriority({
        paymentMethodId: val.paymentMethodId
      }).then(res => {
        this.getDataFun();
      });
    },
    moveFun(val, move) {
      methodMove({
        paymentMethodId: val.paymentMethodId,
        move
      }).then(res => {
        console.log(res);
        this.getDataFun();
      });
    }
  }
};